export default __webpack_public_path__ + "static/media/refused_rejected_icon.1bfa9fc4.svg";